"use client";
import React, { createContext, useContext, useState } from "react";
import { BASE_URL } from "../config/apiconfig";

const BlogContext = createContext();

export const BlogProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);

  const token =
    typeof window !== "undefined"
      ? localStorage.getItem("token")
      : null;

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  /* =====================
        GET BLOGS
  ===================== */
  const getBlogs = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${BASE_URL}/blogs`, {
        headers,
      });
      return await res.json();
    } catch {
      return { status: false, message: "Failed to fetch blogs" };
    } finally {
      setLoading(false);
    }
  };

  /* =====================
        GET SINGLE BLOG
  ===================== */
  const getBlog = async (id) => {
    setLoading(true);
    try {
      const res = await fetch(`${BASE_URL}/blogs/${id}`, {
        headers,
      });
      return await res.json();
    } catch {
      return { status: false, message: "Failed to fetch blog" };
    } finally {
      setLoading(false);
    }
  };

  /* =====================
        CREATE BLOG
  ===================== */
  const createBlog = async (formData) => {
    setLoading(true);
    try {
      const res = await fetch(`${BASE_URL}/blogs`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      return await res.json();
    } catch {
      return { status: false, message: "Blog creation failed" };
    } finally {
      setLoading(false);
    }
  };

  /* =====================
        UPDATE BLOG
  ===================== */
  const updateBlog = async (id, formData) => {
    setLoading(true);
    try {
      const res = await fetch(`${BASE_URL}/blogs/${id}`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      return await res.json();
    } catch {
      return { status: false, message: "Blog update failed" };
    } finally {
      setLoading(false);
    }
  };

  /* =====================
        DELETE BLOG
  ===================== */
  const deleteBlog = async (id) => {
    setLoading(true);
    try {
      const res = await fetch(`${BASE_URL}/blogs/${id}`, {
        method: "DELETE",
        headers,
      });

      return await res.json();
    } catch {
      return { status: false, message: "Blog delete failed" };
    } finally {
      setLoading(false);
    }
  };

  return (
    <BlogContext.Provider
      value={{
        getBlogs,
        getBlog,
        createBlog,
        updateBlog,
        deleteBlog,
        loading,
      }}
    >
      {children}
    </BlogContext.Provider>
  );
};

export const useBlogs = () => useContext(BlogContext);